export default "\r\n<app-nica-tabs name=\"dashboard\" [isActiveClose]=\"true\"></app-nica-tabs>\r\n"